export const SEARCH_AREA = "SearchPortal";